/* eslint-disable react/no-find-dom-node */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { modalOpen, modalType } from '../../redux/actions';
import Group from '../Group';
import Button from '../Button';
import Text from '../Text';
import Lottie from '../LottieControl';
import { userListner, removeUserFromDashboard } from '../../firebase';
import theme, { rem } from '../../theme';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
`;

const StyledTextIntro = styled(Text)`
  margin-bottom: ${rem(20)};
`;

const StyledText = styled(Text)`
  margin-bottom: ${rem(10)};
`;

const StyledContentWrapper = styled(Group)`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

const StyledButtonGroup = styled(Group)`
  margin-top: ${rem(20)};

  button {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: ${rem(20)};
    width: ${rem(350)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledLoading = styled(Lottie)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** todo */
const removeUser = props => {
  const { activeDashboardId, id, returnModal, closeModals } = props;

  //States
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});

  //Translation
  const [t] = useTranslation(['button', 'modal', 'common']);

  useEffect(() => {
    if (id) {
      getData();
    }
    document.getElementById('globalModal').firstElementChild.style.height =
      'auto';
    document.getElementById('globalModal').firstElementChild.style.width =
      '25rem';
  }, []);

  /** Get all the dashboard data */
  const getData = () => {
    userListner
      .child(id)
      .child('public')
      .child('name')
      .once('value', snapshot => {
        if (snapshot.val()) {
          setUserData(snapshot.val());
          setLoading(false);
        } else {
          setUserData(t('common:tutor'));
          setLoading(false);
        }
      });
  };

  /** Return Chat messages */
  return loading ? (
    <StyledLoading animation='loading' animationWidth={400} />
  ) : (
    <StyledWrapper>
      <StyledContentWrapper fullwidth>
        <StyledText
          align='center'
          text={t('modal:removeuser.title')}
          textColor='#fff'
          textStyle='h3'
          tag='h1'
        />

        <StyledTextIntro
          align='center'
          text={t('modal:removeuser.text', {
            name: userData,
          })}
          textColor='#fff'
          textStyle='h6'
          tag='p'
        />

        <StyledButtonGroup fullwidth>
          <Button
            variant='contained'
            onClick={() => {
              if (activeDashboardId)
                removeUserFromDashboard(
                  activeDashboardId,
                  id,
                  true,
                  null,
                  t('toasts:removeduser.text'),
                  t('toasts:owner.new')
                );
              closeModals();
            }}
            bgColor={theme.color.danger}
            text={{
              align: 'center',
              text: t('button:remove.usersmall'),
              textColor: '#fff',
            }}
          />
          <Button
            variant='contained'
            text={{
              align: 'center',
              text: t('button:cancel.cancel'),
              textColor: '#fff',
            }}
            onClick={() => {
              if (returnModal) {
                props.modalOpen(true);
                props.modalType(['editRoles', activeDashboardId, id]);
              } else {
                closeModals();
              }
            }}
            bgColor={theme.color.cancel}
          />
        </StyledButtonGroup>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

removeUser.propTypes = {
  /** Active dashboard Id */
  activeDashboardId: PropTypes.string,
  /** User Id */
  id: PropTypes.string,
  /** Return the previous modal page */
  returnModal: PropTypes.bool,
  /** Close function for the modal */
  closeModals: PropTypes.func,
};

removeUser.defaultProps = {
  activeDashboardId: null,
  id: null,
  closeModals: null,
  returnModal: true,
};

export default connect(null, {
  modalType,
  modalOpen,
})(removeUser);
